import getStaticData from "common/fetch/getStaticData";

import Layout from "components/common/Layout";
import CompanyFormation from "components/templates/common/company-formation-country";

import dataJson from "./data.json";

export default function Home({ data }) {
  return (
    <Layout locationRouter="offshore" navLight={true} page={data.page}>
      <CompanyFormation data={data} dataJson={dataJson} />
    </Layout>
  );
}

export const getStaticProps = async () => {
  const data = await getStaticData({
    locale: "offshore",
    uri: "company-formation/cayman-islands/",
    data_package: 41,
    postQuery: {
      postPerPage: 3,
      array_post_id: [5859, 4244, 3632],
    },
  });

  return {
    props: {
      data,
      revalidate: 1,
    },
  };
};
